import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { IconButton, Tooltip } from "@mui/material";
import Grid from "@mui/material/Grid";
import { useAllStaffsExportMutation, useStaffsListQuery } from "api/staffs/staffs.mutation";
import ExcelIcon from "assets/admin/excel.svg";
import SearchField from "components/SearchField";
import { Table } from "components/Table";
import { exportToExcel } from "constants/export";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { StaffRolesModal } from "./components/staffRolesModal";
import classes from "./style.module.scss";

const Staffs = () => {
  const [searchParams] = useSearchParams();

  const paramPage = Number(searchParams.get("page")) || 1;

  const [pageFilter, setPageFilter] = useState({
    page: paramPage,
    page_size: 15,
    total: 1,
    count: 0,
  });

  const [searchValue, setSearchValue] = useState("");

  const [staffRolesModal, setStaffRolesModal] = useState({
    open: false,
    selectedStaff: null,
  });

  const staffsQuery = useStaffsListQuery({
    page: pageFilter.page,
    page_size: pageFilter.page_size,
    search: searchValue,
  });

  const tableData = staffsQuery.data?.results ?? [];

  const totalPages = staffsQuery.data?.total ?? pageFilter.total;

  const exportStaffsMutation = useAllStaffsExportMutation();

  const handleExportExcel = () => {
    exportStaffsMutation.mutate(undefined, {
      onSuccess: (res) => {
        const allRows = Array.isArray(res) ? res : res?.results ?? [];

        exportToExcel(columns, allRows, "staffs.xlsx");
      },
    });
  };

  const handleOpenStaffRolesModal = (row) => {
    setStaffRolesModal({
      open: true,
      selectedStaff: row,
    });
  };

  const handleCloseStaffRolesModal = () => {
    setStaffRolesModal({
      open: false,
      selectedStaff: null,
    });
  };

  const handleRolesChanged = async () => {
    const response = await staffsQuery.refetch();

    const freshRows = response?.data?.results ?? [];

    const freshSelectedStaff = freshRows.find(
      (item) => item.id === staffRolesModal.selectedStaff?.id
    );

    setStaffRolesModal((prev) => ({
      ...prev,
      selectedStaff: freshSelectedStaff ?? prev.selectedStaff,
    }));
  };

  useEffect(() => {
    if (pageFilter.page !== paramPage) {
      setPageFilter((prev) => ({
        ...prev,
        page: paramPage,
      }));
    }
  }, [paramPage]);

  const columns = [
    {
      field: "sub",
      headerName: "کد پرسنلی",
      minWidth: 90,
      flex: 1,
      sortable: false,
      resizable: false,
    },
    {
      field: "full_name",
      headerName: "نام و نام خانوادگی",
      minWidth: 150,
      flex: 1,
      sortable: false,
      resizable: false,
    },
    {
      field: "roles",
      headerName: "سمت ها",
      minWidth: 140,
      flex: 1,
      sortable: false,
      resizable: false,
      renderCell: ({ row }) =>
        [...new Set(row?.roles?.map((r) => r.role_display) ?? [])].join(" - "),
    },
    {
      field: "picurl",
      headerName: "عکس پرسنلی",
      minWidth: 100,
      flex: 1,
      sortable: false,
      resizable: false,
      hideInExport: true,
      renderCell: ({ row }) => (
        <img className={classes.picurlImage} src={row?.picurl} alt="profilepicture" />
      ),
    },
    {
      field: "username",
      headerName: "ایمیل",
      minWidth: 150,
      flex: 1,
      sortable: false,
      resizable: false,
      renderCell: ({ row }) => `${row?.username}@iust.ir`,
    },
    {
      field: "action",
      headerName: "",
      minWidth: 90,
      flex: 1,
      sortable: false,
      resizable: false,
      hideInExport: true,
      renderCell: ({ row }) => (
        <div className={classes.nextBox} onClick={() => handleOpenStaffRolesModal(row)}>
          <ArrowBackIosNewIcon className={classes.nextIcon} fontSize="small" />
        </div>
      ),
    },
  ];

  return (
    <>
      <div className={classes.mainDiv}>
        <div className={classes.toolBar}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <SearchField setValueCallback={setSearchValue} variant="standard" />
            </Grid>

            <Grid item xs={0} md={4} />

            <Grid item xs={12} md={4}>
              <div className={classes.manageBar}>
                <Tooltip title="خروجی اکسل">
                  <IconButton
                    onClick={handleExportExcel}
                    color="success"
                    disabled={exportStaffsMutation.isPending}
                  >
                    <img src={ExcelIcon} alt="export-excell" className={classes.customIcon} />
                  </IconButton>
                </Tooltip>
              </div>
            </Grid>
          </Grid>
        </div>

        <Table
          rows={tableData}
          columns={columns}
          totalPages={totalPages}
          loading={staffsQuery.isFetching}
          className={classes.tableContainer}
        />
      </div>

      <StaffRolesModal
        open={staffRolesModal.open}
        onClose={handleCloseStaffRolesModal}
        selectedStaff={staffRolesModal.selectedStaff}
        onRolesChanged={handleRolesChanged}
      />
    </>
  );
};

export default Staffs;
